export default "__VITE_ASSET__osTfbfsq__"